import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../common/Loader";

const AddHomePageModal = ({ isOpen, onClose, onContentAdded }) => {
  const [heading, setHeading] = useState("");
  const [subheading, setSubheading] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [keyPoints, setKeyPoints] = useState([{ title: "", description: "" }]);
  const [loading, setLoading] = useState(false);

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      formData
    );
    return res.data.secure_url;
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
      setImages([...images, ...urls]);
      toast.success("Images uploaded successfully");
    } catch {
      toast.error("Image upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        heading,
        subheading,
        description: description.split("\n").filter(d => d.trim()),
        images,
        keyPoints: keyPoints.filter(k => k.title && k.description)
      };
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/home/create-section`, payload);
      toast.success("Content added");
      onContentAdded(res.data.data);
      onClose();
      // Reset
      setHeading(""); setSubheading(""); setDescription(""); setImages([]); setKeyPoints([{ title: "", description: "" }]);
    } catch {
      toast.error("Failed to add content");
    } finally { setLoading(false); }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50 overflow-auto">
      <div className="bg-white w-full max-w-3xl p-6 rounded relative">
         <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-lg font-bold"
        >
          ×
        </button>

        <h2 className="text-xl font-bold mb-4">Add Home Page Content</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="text" placeholder="Heading" value={heading} onChange={e => setHeading(e.target.value)} className="w-full border px-3 py-2 rounded" required />
          <input type="text" placeholder="Subheading" value={subheading} onChange={e => setSubheading(e.target.value)} className="w-full border px-3 py-2 rounded" required />
          <textarea placeholder="Description (one per line)" value={description} onChange={e => setDescription(e.target.value)} className="w-full border px-3 py-2 rounded" rows={3} />
          <input type="file" multiple onChange={handleImageUpload} />
          <div className="flex flex-wrap gap-2">
            {images.map((img, i) => (
              <div key={i} className="relative w-20 h-20">
                <img src={img} className="w-full h-full object-cover rounded border" />
                <button
                  type="button"
                  onClick={() => setImages(images.filter((_, index) => index !== i))}
                  className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
                >
                  ×
                </button>
              </div>
            ))}
          </div>


          {/* Key Points */}
          {keyPoints.map((kp, i) => (
            <div key={i} className="flex gap-2">
              <input type="text" placeholder="Title" value={kp.title} onChange={e => { const temp = [...keyPoints]; temp[i].title = e.target.value; setKeyPoints(temp); }} className="border px-2 py-1 flex-1" />
              <input type="text" placeholder="Description" value={kp.description} onChange={e => { const temp = [...keyPoints]; temp[i].description = e.target.value; setKeyPoints(temp); }} className="border px-2 py-1 flex-1" />
            </div>
          ))}
          <button type="button" onClick={() => setKeyPoints([...keyPoints, { title: "", description: "" }])} className="bg-blue-500 text-white px-2 py-1 rounded text-sm">+ Add Key Point</button>

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
            <button type="submit" disabled={loading} className="bg-orange-500 px-4 py-2 text-white rounded">{loading ? <Loader /> : "Add Content"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddHomePageModal;
